var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{staticStyle:{"width":"110%"},attrs:{"type":"radialBar","options":_vm.chartOptions,"series":[_vm.series]}})
}
var staticRenderFns = []

export { render, staticRenderFns }